module.exports = __webpack_public_path__ + "static/media/conference-room.519c6423.webp";